<template>
	<div>
	<div class="actDiv" title="收费统计">
				<label>小区</label>
				<a-select style="width:9rem; margin: 0 0.625rem;font-size: 0.6875rem;" v-model="theNeighbor" placeholder="请选择小区"
					label-in-value option-filter-prop="children" :filter-option="filterOption" show-search @change="onChange">
					<a-select-option v-for="(item,index) in searchneighborList" :key="item.pId" :value="item.pId">
						{{item.neighborName}}
					</a-select-option>
				</a-select>
				<a-date-picker @change="onChangeStrat"  style="width:9rem; margin: 0 0.625rem;font-size: 0.6875rem;"/>
				<a-date-picker @change="onChangeEnd" style="width:9rem; margin: 0 0.625rem;font-size: 0.6875rem;"/>
				<a-select style="width:9rem; margin: 0 0.625rem;font-size: 0.6875rem;" v-model="searchmodel.pre"
					option-filter-prop="children" :filter-option="filterOption" show-search>
					<a-select-option v-for="(item,index) in payList" :value="item.value">{{item.label}}
					</a-select-option>
				</a-select>
				<label>缴费方式</label>
				<a-select style="width:12rem; margin: 0 0.625rem;font-size: 0.6875rem;" v-model="searchmodel.paytype"
					option-filter-prop="children" :filter-option="filterOption" show-search>
					<a-select-option v-for="(item,index) in payTypeList" :value="item.value">{{item.label}}
					</a-select-option>
				</a-select>
				<a-button   @click="query" style="margin: 0 0.625rem;" size="small"  icon="search">查找</a-button>
				<a-button   @click="print" style="margin: 0 0.625rem;" size="small"  icon="printer">打印</a-button>
	</div>
	<vxe-table  align="center" :data="list"  border height="300"  ref="mTable" show-overflow="title" size="mini"  :cell-style="cellClassName"
					  resizable highlight-hover-row :loading="loading"  @checkbox-all="selectAllEvent" @checkbox-change="selectChangeEvent"
					  :checkbox-config="{trigger: 'row', highlight: true, range: true}"  row-id="c_id">
					  <vxe-table-column type="seq" width="45"></vxe-table-column>
					  <vxe-table-column type="checkbox"  width="45"></vxe-table-column>
					  <vxe-table-column title="用户号" field="c_num" ></vxe-table-column>
					  <vxe-table-column title="用户名" field="customerName"></vxe-table-column>
					  <vxe-table-column title="地址" field="customerAddr" ></vxe-table-column>
					  <vxe-table-column title="余额" field="customerBalance"></vxe-table-column>
					   <vxe-table-column title="手机" field="customerMobile"></vxe-table-column>
					   <vxe-table-column title="预付费" field="payPre"  :formatter="getPrePaySign"></vxe-table-column>
					   <vxe-table-column title="缴费金额" field="amount" ></vxe-table-column>
					   <vxe-table-column title="缴费时间" field="actionTime" :formatter="getTimeFormatter"></vxe-table-column>
					   <vxe-table-column title="收费员" field="adminName"></vxe-table-column>
					   <vxe-table-column title="缴费渠道" field="paytype"  :formatter="getPaytype"></vxe-table-column>
					   <vxe-table-column title="流水号" field="payid"></vxe-table-column>
	</vxe-table>
	<a-row :gutter="5" style="margin-top: 1.25rem;">
		<a-col :span="6">
			<a-table size="small" :columns="admincolumns" :data-source="adminList" bordered
				:rowKey="admincolumns.adminName" :pagination="false" :loading="loading">
			</a-table>

		</a-col>
		<a-col :span="6">
			<a-table size="small" :columns="payinfocolumns" :data-source="payinfoList" bordered
				:rowKey="payinfoList.paytype" :pagination="false" :loading="loading">
				<span slot="PaySlot" slot-scope="text, info">
					{{getName(info.paytype)}}
				</span>
			</a-table>
		</a-col>
		<a-col :span="6">
			<a-table size="small" :columns="neighborcolumns" :data-source="neighborList" bordered
				:rowKey="neighborList.neighborName" :pagination="false" :loading="loading">
			</a-table>
		</a-col>
		<a-col :span="6">
			<a-table size="small" :columns="balancecolumns" :data-source="balanceList" bordered
				:rowKey="balanceList.neighborName" :pagination="false" :loading="loading">
			</a-table>
		</a-col>
	</a-row>
</div>
</template>

<script>
	export default {
		data() {
			const admincolumns = [{
					title: '管理员',
					dataIndex: 'adminName',
					width: 80,
					className:'v-cell',
				},
				{
					title: '收费合计',
					dataIndex: 'amount',
					width: 80,
					className:'v-cell',
				}
			];
			const payinfocolumns = [{
					title: '缴费渠道',
					dataIndex: 'paytype',
					width: 80,
					scopedSlots: {
						customRender: 'PaySlot'
					},
					className:'v-cell',
				},
				{
					title: '金额',
					dataIndex: 'amount',
					width: 80,
					className:'v-cell',
				}
			];
			const neighborcolumns = [{
					title: '小区',
					dataIndex: 'neighborName',
					width: 80,
					className:'v-cell',
				},
				{
					title: '金额',
					dataIndex: 'amount',
					width: 80,
					className:'v-cell',
				}
			];
			const balancecolumns = [{
					title: '小区',
					dataIndex: 'neighborName',
					width: 80,
					className:'v-cell',
				},
				{
					title: '余额',
					dataIndex: 'amount',
					width: 80,
					className:'v-cell',
				}
			];
			return {
				admincolumns,
				payinfocolumns,
				neighborcolumns,
				balancecolumns,
				theNeighbor: undefined,
				loading: false,
				selectedRows: [],
				searchmodel: {
					n_id: 0,
					pre: 1,
					paytype: 3,
					start: null,
					end: null,
					c_ids: '',
					pay_pid_ids: '',
				},
				adminList: [],
				payinfoList: [],
				neighborList: [],
				balanceList: [],
				list: [],
				searchneighborList: [],
				payList: [{
						value: 1,
						label: "预付费"
					},
					{
						value: 0,
						label: "后付费"
					},
					{
						value: 2,
						label: "全部"
					},
				],
				payTypeList: [
					{
						value: 2,
						label: "招商银行缴费"
					},
					{
						value: 1,
						label: "支付宝缴费"
					},
					{
						value: 0,
						label: "营业厅缴费"
					},
					{
						value: 3,
						label: "请选择"
					},
				],
			}
		},
		methods: {
			cellClassName({ row, rowIndex, column }){
				let style = null;
				if(this.selectedRows.includes(row.c_id)){
					style =  {
						backgroundColor: '#FFE48A',
					}
				}else{
					style = {
							'color':'#000',
					}	
				}	
				return style;
			},
			scrollSome:function(){
				this.$refs.mTable.refreshScroll();
			},
			selectAllEvent ({ checked, records }) {
				if(checked){
					this.selectedRows = records;
				}else{
					this.selectedRows = [];
				}
				this.checkSelectRows();
			},
			selectChangeEvent({ checked, records }) {
				this.selectedRows = records;
				this.checkSelectRows();
			},
			getTimeFormatter({cellValue}){
				if(cellValue == null){
					return "";
				}else{
					let date = new Date(cellValue);
					return this.Config.formatDate(date);
				}
			},
			getPrePaySign({cellValue}){
				return this.Config.getValueByNameFromList(cellValue,this.Config.getPrepaySignList());
			},
			getPaytype({cellValue}){
				return this.Config.getValueByNameFromList(cellValue,this.Config.getPayTypeList());
			},
			filterOption(input, option) {
				return (option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0);
			},
			onChangeStrat(moment) {
				let date = new Date(moment);
				var myyear = date.getFullYear();
				var mymonth = date.getMonth() + 1;
				var myweekday = date.getDate();
				var myHour = date.getHours();
				var myMinute = date.getMinutes();
				var mySecond = date.getSeconds();

				if (mymonth < 10) {
					mymonth = "0" + mymonth;
				}
				if (myweekday < 10) {
					myweekday = "0" + myweekday;
				}
				this.searchmodel.start = myyear + "-" + mymonth + "-" + myweekday;
			},
			onChangeEnd(moment) {
				let date = new Date(moment);
				var myyear = date.getFullYear();
				var mymonth = date.getMonth() + 1;
				var myweekday = date.getDate();
				var myHour = date.getHours();
				var myMinute = date.getMinutes();
				var mySecond = date.getSeconds();

				if (mymonth < 10) {
					mymonth = "0" + mymonth;
				}
				if (myweekday < 10) {
					myweekday = "0" + myweekday;
				}
				this.searchmodel.end = myyear + "-" + mymonth + "-" + myweekday;
			},
			onChange() {
				this.selectedRows = [];
				this.searchmodel.c_ids  = null;
				this.searchmodel.pay_pid_ids = null;
			},

			checkSelectRows:function() {
				let c_ids = '';
				let pay_pid_ids = '';
				for (var i = 0; i < this.selectedRows.length; i++) {
					var row = this.selectedRows[i];
					if (i != 0) {
						c_ids += "-";
						pay_pid_ids += "-";
					}
					c_ids += row.c_id;
					pay_pid_ids += row.pay_pid;
				}
				this.searchmodel.c_ids = c_ids;
				this.searchmodel.pay_pid_ids = pay_pid_ids;
			},
			getPreState: function(prepaysign) {
				if (prepaysign == 1) {
					return '预';
				}
				if (prepaysign == 0) {
					return '后';
				}
			},
			getName: function(paytype) {
				if(paytype == 2){
					return '招商银行'
				}else if (paytype == 1) {
					return '支付宝';
				} else if (paytype == 0) {
					return '营业厅';
				} else {
					return '合计';
				}
			},
			getTime: function(actionTime) {
				let date = new Date(actionTime);
				return this.Config.formatDate(date);
			},
			print: function() {
				let url = this.Api.getLastUrl(this.Api.STATIS_PAY_INFO_STATIS_Print_URL);
				if (this.searchmodel.start == null || this.searchmodel.end == null) {
					this.$message.info("请输入开始日期和截止日期");
					return;
				}
				if (this.theNeighbor != undefined) {
					this.searchmodel.n_id = this.theNeighbor.key;
					this.searchmodel.n_name = this.theNeighbor.label;
				} else {
					this.searchmodel.n_name = '';
				}
				let userInfo = this.Config.getUserLocal();

				window.open(url + "?n_id=" + this.searchmodel.n_id + "&UserId=" + userInfo.pId + "&n_name=" + this
					.searchmodel.n_name +
					"&start=" + this.searchmodel.start + "&end=" + this.searchmodel.end +
					"&pre=" + this.searchmodel.pre + "&paytype=" + this.searchmodel.paytype + "&c_ids=" + this
					.searchmodel.c_ids +
					"&pay_pid_ids=" + this.searchmodel.pay_pid_ids, "_blank");
			},
			query: function() {
				let url = this.Api.getLastUrl(this.Api.STATIS_GET_PAY_INFO_STATIS_URL);
				if (this.theNeighbor != undefined) {
					this.searchmodel.n_id = this.theNeighbor.key;
					this.searchmodel.n_name = this.theNeighbor.label;
				}
				if (this.searchmodel.start == null || this.searchmodel.end == null) {
					this.$message.info("请输入开始日期和截止日期");
					return;
				}
				this.loading = true;
				this.Api.fetchPost(url, this.searchmodel).then((data) => {
					this.loading = false;
					let code = data.data.code;
					let result = data.data.result;
					let msg = data.data.message;
					if (code == this.Api.HTTP_OK_CODE) {
						this.list = result.listPayInfo;
						this.adminList = result.listAdminSum;
						this.payinfoList = result.listBalance;
						this.neighborList = result.neighborMoneyAll;
						this.balanceList = result.currentBalanceAll;
					} else {
						this.$message.error(msg);
					}
				}).catch((error) => {
					console.log(error);
					this.loading = false;
				});


			},
			queryNeighbors: function() {
				let url = this.Api.getLastUrl(this.Api.NEIGHBOR_SEARCH_LIST_URL);
				this.Api.fetchPostWithForm(url).then((data) => {
					let code = data.data.code;
					let result = data.data.result;
					let msg = data.data.message;
					if (code == this.Api.HTTP_OK_CODE) {
						this.searchneighborList = result;
					} else {
						this.$message.error(msg);
					}
				}).catch((error) => {
					console.log(error);
				});
			},
		},
		created() {
			this.queryNeighbors();
		},
	}
</script>

<style>
</style>
